import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import AxiosInstance from '../../../helpers/AxiosInstance';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const useForm = (optionsToDisplay) => {
  const { addButton, editAction, deleteAction, viewAction } = optionsToDisplay;
  const [listBook, setListBook] = useState([]);
  const [totalItems, setTotalItems] = useState(null);
  const [totalPages, setTotalPages] = useState(null);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const { t, i18n } = useTranslation();

  const location = useLocation();
  const [query, setQuery] = useState({
    page: null,
    order: 'publicationNumber DESC',
    keyword: '',
    limit: 10,
    queryType: 'DEFAULT',
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const page = parseInt(queryParams.get('page'));
    const order = queryParams.get('order');
    const keyword = queryParams.get('keyword');
    setQuery((prev) => ({
      ...prev,
      page: page ? page - 1 : 0,
      order: order ? order : query.order,
      keyword: keyword ? keyword : '',
    }));
  }, [location]);

  useEffect(() => {
    if (query.page !== null) {
      findAllBooks();
    }
  }, [query]);

  const findAllBooks = () => {
    setLoading(true);
    AxiosInstance.get('/book', {
      params: query,
    })
      .then((response) => {
        setListBook(response.data.items);
        setTotalPages(response.data.totalPages);
        setTotalItems(response.data.totalItems);
        setLoading(false);
      })
      .catch((error) => {
        Swal.fire(t('book.ERROR_GET_BOOKS'), '', 'error');
        setLoading(false);
      });
  };

  const updateBook = (id) => {
    history.push({
      pathname: '/book/update',
      params: {
        id: id,
      },
    });
  };

  const detailsBook = (id) => {
    history.push({
      pathname: '/book/details',
      params: {
        id: id,
      },
    });
  };

  const viewBook = (id) => {
    history.push({
      pathname: '/book/view',
      params: {
        id: id,
      },
    });
  };

  const deleteBook = (id) => {
    Swal.fire({
      title: t('swal.are_you_sure'),
      text: t('swal.delete_permanently'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: t('swal.no'),
      confirmButtonText: t('swal.yes_delete'),
    }).then((result) => {
      if (result.isConfirmed) {
        AxiosInstance.delete('/book/' + id)
          .then((response) => {
            Swal.fire(t('book.SUCCESS_DELETE_BOOK'), '', 'success');
            findAllBooks();
          })
          .catch((error) => {
            Swal.fire(t('book.ERROR_DELETE_BOOK'), '', 'error');
          });
      }
    });
  };

  const attributes = [
    { name: 'publicationNumber', title: t('table.publicationNumber'), nestedObject: [], type: 'text', order: true },
    { name: 'title', title: t('table.title'), nestedObject: [], type: 'text', order: true },
    { name: 'nbrViews', title: t('table.nbrViews'), nestedObject: [], type: 'text', order: true },
    { name: 'rating', title: t('table.rating'), nestedObject: [], type: 'rating', order: true },
    { name: 'publishingHouse', title: t('table.publishingHouse'), nestedObject: [], type: 'text', order: true },
    { name: 'releaseDate', title: t('table.releaseDate'), nestedObject: [], type: 'date', order: true },
  ];

  const actions = {
    details: detailsBook,
    delete: editAction ? deleteBook : null,
    update: deleteAction ? updateBook : null,
    view: viewAction ? viewBook : null,
  };

  return {
    attributes,
    actions,
    listBook,
    findAllBooks,
    totalPages,
    loading,
    query,
  };
};

export default useForm;
